import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

// Extend dayjs with isSameOrBefore plugin
dayjs.extend(isSameOrBefore);

export const validateCreateDestinationDelivery = (validateFieldRequired, setValidateFieldRequired, name, value) => {
  let fileValidate = name.field;
  switch (fileValidate) {
    case "vehicle":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldVehicle: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldVehicle: true,
      });
      return Promise.resolve();
    case "depart_at":
      if (value === "") {
        setValidateFieldRequired({
          ...validateFieldRequired,
          fieldDepartAt: false,
        });
        return Promise.reject();
      }
      setValidateFieldRequired({
        ...validateFieldRequired,
        fieldDepartAt: true,
      });
      return Promise.resolve();
  }
};

export const validateSubmitCreateDestinationDelivery = (input, data) => {
  const { vehicle, depart_at } = input || {};
  const { type } = data || {};
  let isValid = true;
  if (vehicle === undefined) {
    isValid = false;
  }
  if (
    type === "CREATE" &&
    (depart_at === null || depart_at === undefined || dayjs(depart_at).isSameOrBefore(dayjs()))
  ) {
    isValid = false;
  }

  return { isValid: isValid };
};

export const validateSubmitCreateDestinationDeliveryForPackage = (input) => {
  let isValid = true;
  if (input.package_service === undefined || input.package_service === 0) {
    isValid = false;
  }

  return { isValid: isValid };
};
